export class GiftInfoConfig {
    id: number;
    giftCode: string;
    giftId: number;
    packageCode: string;
    campaignCode: string;
    totalInventory: number;
    currentInventory: number;
    probability: number;
    startTime: string;
    endTime: string;
    sendNum: number;
    amount: number;
    remark: string;
}

export class AddStockDto {
    giftId: number;
    totalInventory: number = 0;
    packageId: number;
    probability: number = 0;
    startTime: string;
    endTime: string;
    sendNum: number = 1;
    amount: number = 1;
    remark: string;
    commonStockId: number = 0;
}

export class UpdateStockDto {
    id: number;
    probability: number;
    sendNum: number;
    amount: number;
    remark: string;
    commonStockId: number;
    inventoryChange: number = 0;
}


export class CreateParamsDto {
    campaignId: number = 0;
    packageId: number = 0;
    startTime: any;
    endTime: any;
}

export class StockTableDto {
    key: string;
    value: GiftInfoConfig[] = new Array<GiftInfoConfig>();
}
